/* BRENORA: Produktseite – Set-Auswahl, Geschenk-/Bild-Text-Button ([data-brenora-atc]) und Sticky-Offset.
   Keine Preisberechnung im JS (Preise kommen fertig aus Liquid). */

/** Haupt-Produktformular (Horizon product-form-component) einer Section bzw. der Haupt-Produktsection. */
function findProductForm(sectionId, productId) {
  const byProduct = productId ? `[data-product-id="${productId}"]` : '';
  if (sectionId) {
    const el = document.querySelector(`#shopify-section-${sectionId} product-form-component${byProduct}`);
    if (el) return el;
  }
  return (
    document.querySelector(`.product-information product-form-component${byProduct}`) ||
    document.querySelector('.product-information product-form-component')
  );
}

class BrenoraSetSelector extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange);
    window.addEventListener('pageshow', this.#apply);
    this.#apply();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
    window.removeEventListener('pageshow', this.#apply);
  }

  /** @param {Event} event */
  #onChange = (event) => {
    const target = event.target;
    if (target instanceof HTMLInputElement && target.name === 'brenora_set') this.#apply();
  };

  /** Gewählte Menge in Horizons Mengen-Komponente des Hauptformulars schreiben (ohne QuantitySelectorUpdateEvent). */
  #apply = async () => {
    const checked = /** @type {HTMLInputElement | null} */ (this.querySelector('input[name="brenora_set"]:checked'));
    if (!checked) return;
    const value = String(parseInt(checked.value, 10) || 1);
    const form = findProductForm(this.dataset.sectionId, this.dataset.productId);
    if (!form) return;
    // PF: Menge sofort ins Formularfeld schreiben (auch bevor Horizons Mengen-Komponente geladen ist),
    // damit ein frühes oder natives Absenden (ohne JS) schon die Set-Menge trägt.
    const early = /** @type {HTMLInputElement | null} */ (form.querySelector('input[name="quantity"]'));
    if (early) early.value = value;
    await customElements.whenDefined('quantity-selector-component');
    const selector = /** @type {any} */ (form.querySelector('quantity-selector-component'));
    if (selector && typeof selector.setValue === 'function') {
      selector.setValue(value);
    } else {
      const input = /** @type {HTMLInputElement | null} */ (form.querySelector('input[name="quantity"]'));
      if (input) input.value = value;
    }
  };
}

if (!customElements.get('brenora-set-selector')) customElements.define('brenora-set-selector', BrenoraSetSelector);

/* Buttons mit [data-brenora-atc] lösen den Haupt-Kaufbutton aus – wie Horizons Sticky-Leiste
   (programmatischer Klick → gleiche Validierung, Spinner, Drawer und Set-Menge). */
if (!window.__brenoraAtcBound) {
  window.__brenoraAtcBound = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-brenora-atc]') : null;
    if (!trigger || trigger.hasAttribute('disabled')) return;
    const form = findProductForm(trigger.getAttribute('data-section-id'), trigger.getAttribute('data-product-id'));
    const button = /** @type {HTMLButtonElement | null} */ (form?.querySelector('[ref="addToCartButton"]') ?? null);
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;
    const before = button.dataset.puppet;
    button.dataset.puppet = 'true';
    button.click();
    if (before === undefined) delete button.dataset.puppet;
    else button.dataset.puppet = before;
  });
}

/* Sticky-Leiste (Horizon): zusätzlich ausblenden, solange der Haupt-Kaufbutton noch unterhalb des Sichtbereichs liegt
   (wie Referenz: Leiste nur, wenn man am Button vorbeigescrollt ist). Horizons eigener Zustand (data-stuck) bleibt unberührt.
   --b-sticky-offset: Höhe der sichtbaren Leiste (sonst 0px) auf <html>, z. B. für die Geschenk-Pille. */
if (!window.__brenoraStickyBound) {
  window.__brenoraStickyBound = true;
  const root = document.documentElement;
  let below = true;
  const update = () => {
    const bar = /** @type {HTMLElement | null} */ (document.querySelector('.sticky-add-to-cart__bar'));
    if (!bar) return root.style.setProperty('--b-sticky-offset', '0px');
    bar.classList.toggle('b-sticky--below', below);
    const visible = bar.dataset.stuck === 'true' && !below && getComputedStyle(bar).display !== 'none';
    root.style.setProperty('--b-sticky-offset', visible ? `${Math.round(bar.getBoundingClientRect().height)}px` : '0px');
  };
  const init = () => {
    const bar = document.querySelector('.sticky-add-to-cart__bar');
    const buy = document.querySelector('.product-information .buy-buttons-block');
    if (!bar || !buy) return root.style.setProperty('--b-sticky-offset', '0px');
    new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
    new IntersectionObserver(([entry]) => {
      if (!entry) return;
      below = !entry.isIntersecting && entry.boundingClientRect.top >= (entry.rootBounds?.bottom ?? window.innerHeight);
      update();
    }).observe(buy);
    window.addEventListener('resize', update, { passive: true });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}
